<app-attendee-card-collection
  [description]="description"
  [title]="title"
  [link]="link"
  [showCta]="seeMore"
>
  <ng-container *ngFor="let advice of advices">
    <a
      *appListItem
      [href]="[advice.url]"
      target="_blank"
      [rel]="'noopener noreferrer'"
      [attr.aria-label]="advice.title"
    >
      <app-attendee-advice-card
        [title]="advice.title"
        [description]="advice.summary"
        [image]="advice.imageUrl"
      >
      </app-attendee-advice-card>
    </a>
  </ng-container>
</app-attendee-card-collection>
